require('./transactionsListContainer.scss')

module.exports = {
  template: require('./transactionsListContainer.pug')()
  controller: require('./transactionsListContainer.ctrl')
}
